import React from "react";
import ReactMarkdown from "react-markdown";

type MarkdownComponentProps = {
  node: any;
  [key: string]: any;
};

// Custom element renderers for the markdown used in product copy.
const markdownComponents = {
  p: ({ node, ...props }: MarkdownComponentProps) => (
    <p className="mb-2" {...props} />
  ),
  em: ({ node, ...props }: MarkdownComponentProps) => (
    <em
      className="italic font-italic"
      style={{ fontStyle: "italic" }}
      {...props}
    />
  ),
  strong: ({ node, ...props }: MarkdownComponentProps) => (
    <strong className="font-bold" {...props} />
  ),
  ul: ({ node, ...props }: MarkdownComponentProps) => (
    <ul className="list-disc ml-5 mb-2" {...props} />
  ),
  ol: ({ node, ...props }: MarkdownComponentProps) => (
    <ol className="list-decimal ml-5 mb-2" {...props} />
  ),
  li: ({ node, ...props }: MarkdownComponentProps) => (
    <li className="mb-1" {...props} />
  ),
  h1: ({ node, ...props }: MarkdownComponentProps) => (
    <h1 className="text-xl font-semibold mb-2" {...props} />
  ),
  h2: ({ node, ...props }: MarkdownComponentProps) => (
    <h2 className="text-lg font-semibold mb-2" {...props} />
  ),
  a: ({ node, ...props }: MarkdownComponentProps) => (
    <a className="text-blue-600 hover:underline" {...props} />
  ),
};

// Normalize spacing around _italic_ / **bold** markers in product copy.
export const processMarkdown = (text: string | null | undefined): string => {
  if (typeof text !== "string" || !text.trim()) return "";

  return text
    .replace(/([ \t\r\v\f]*)_([^_]+)_([ \t\r\v\f]*)/g, " _$2_ ")
    .replace(/([^_])_([^_]+)_([^_])/g, "$1 _$2_ $3")
    .replace(/([ \t\r\v\f]*)\*\*([^*]+)\*\*([ \t\r\v\f]*)/g, " **$2** ")
    .replace(/([^*])\*\*([^*]+)\*\*([^*])/g, "$1 **$2** $3")
    .trim();
};

interface SafeMarkdownProps {
  content: string;
}

export const SafeMarkdown: React.FC<SafeMarkdownProps> = ({ content }) => (
  <ReactMarkdown className="markdown-content" components={markdownComponents}>
    {content}
  </ReactMarkdown>
);
